/* eslint-disable import/prefer-default-export */
export const ENTITIES_DELETE = 'app/entities/ENTITIES_DELETE';
